import { useLocation, useOutlet } from 'react-router-dom';
import { KeepAlive, useKeepAliveRef } from 'keepalive-for-react';
import { useMemo } from 'react';
import BottomNavigation from './BottomNavigation';

function Layout() {
  const location = useLocation();
  const outlet = useOutlet();
  const aliveRef = useKeepAliveRef();

  const cacheKey = useMemo(() => {
    return location.pathname + location.search;
  }, [location.pathname, location.search]);

  return (
    <div className="layout">
      {/* Страницы прогулки не кешируются: у них живая геолокация и таймер,
          а «Начать заново» открывает тот же путь с новым `?t=`. Шаблон
          `/\/walk$/` этого не ловил — ключ кеша содержит search, и строка
          оканчивалась на метку. Оставался живым старый экземпляр
          с пройденной прогулкой, и его эффект сохранения возвращал
          прогресс на сервер сразу после сброса */}
      <KeepAlive
        activeCacheKey={cacheKey}
        max={7}
        aliveRef={aliveRef}
        transition={false}
        exclude={/\/walk(\?|$)/}
      >
        {outlet}
      </KeepAlive>
      <BottomNavigation />
    </div>
  );
}

export default Layout;
